// extracted by mini-css-extract-plugin
export var icon = "Uxrd4bGayMF8gkLTj5gF";
export var onboardServicesList = "aWzuLrLeitV1zLU5ntRG";